var map = {
	"./add-expenses.png": 4692,
	"./bank.png": 6104,
	"./bill.png": 3894,
	"./box.png": 8573,
	"./buyers-report.png": 6871,
	"./cart-dollar.png": 2511,
	"./cart.png": 4623,
	"./corrupted-stores.png": 1577,
	"./credit-card.png": 5022,
	"./customer-invoice.png": 4538,
	"./customer-reports.png": 543,
	"./customer-sales-records-in-year.png": 1688,
	"./customers-dealing-with-delegates.png": 3110,
	"./customers-type.png": 3922,
	"./debt.png": 4482,
	"./delegate-target.png": 3831,
	"./delegates-debts.png": 8616,
	"./delegates-target-reports.png": 2783,
	"./delegates_receive_money.png": 3765,
	"./delivery-boy.png": 7355,
	"./delivery-courier.png": 4807,
	"./deposit.png": 9350,
	"./diamond.png": 9878,
	"./discount.png": 2165,
	"./donation.png": 2767,
	"./dropdown.svg": 4685,
	"./england-flag.jpg": 6396,
	"./expense.png": 1014,
	"./expense_type.png": 6367,
	"./expenses-report.png": 2371,
	"./expenses-type.png": 2929,
	"./eye.png": 5523,
	"./financial-profit.png": 6614,
	"./gifts-sales-reports.png": 4346,
	"./governorate.png": 3358,
	"./group.png": 2804,
	"./growth.png": 8182,
	"./home.png": 3686,
	"./info.png": 1797,
	"./installment_payment.png": 2092,
	"./inventory.png": 7389,
	"./invoice.png": 9897,
	"./invoice_reports.png": 5325,
	"./invoices.png": 568,
	"./iraq-flag.png": 2203,
	"./key.png": 8937,
	"./kurdish-flag.jpg": 9688,
	"./login-bg.jpg": 4474,
	"./logo.jpg": 9407,
	"./logo.svg": 4464,
	"./logout.png": 5152,
	"./medical-report.png": 7751,
	"./money-bag.png": 8136,
	"./nested-categories.png": 1639,
	"./online-payment.png": 3902,
	"./order-invoice-reports.png": 5207,
	"./order-invoice.png": 5511,
	"./pay_customer_debt.png": 3897,
	"./payment.png": 3186,
	"./pie-chart.png": 1212,
	"./pre-invoice-reports.png": 5246,
	"./price-difference-types.png": 6177,
	"./printer.png": 943,
	"./product-sales-records-in-year.png": 4944,
	"./product.png": 8963,
	"./products-sales-records.png": 5293,
	"./products-sold-by-customers.png": 1178,
	"./profile.png": 7020,
	"./profits.png": 7548,
	"./purchase-orders.png": 6046,
	"./refund.png": 9497,
	"./region.png": 8870,
	"./report.png": 2494,
	"./reports.png": 7787,
	"./representative.png": 3173,
	"./return-invoice-orders.png": 5224,
	"./return-invoice-reports.png": 5784,
	"./return-invoice.png": 9589,
	"./return.png": 2540,
	"./reveal-customer-account.png": 8767,
	"./reveal-supplier-account.png": 6223,
	"./safe-deposit.png": 5330,
	"./safe-operations-reports.png": 8267,
	"./safe-operations.png": 9522,
	"./sale-tag.png": 4388,
	"./sales-invoice-dinar.png": 2295,
	"./sales-invoice.png": 3678,
	"./search.png": 5174,
	"./settings.png": 7946,
	"./shop.png": 9200,
	"./shopping-bags.png": 8693,
	"./shopping-cart-plus.png": 5951,
	"./shopping-cart-sale.png": 2864,
	"./shopping-cart.png": 3423,
	"./shortcuts.png": 7715,
	"./statistics.png": 776,
	"./store_reports.png": 1503,
	"./supplier-data.png": 7607,
	"./take.png": 4585,
	"./taxi-driver.png": 520,
	"./transfer-products-reports.png": 725,
	"./transfer-products.png": 738,
	"./transfer.png": 7808,
	"./translation.png": 6938,
	"./truck-delegates.png": 7090,
	"./unsold-customers-report.png": 1047,
	"./user.png": 263,
	"./users-setting.png": 746,
	"./wallet.png": 8744
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7300;